<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.title" placeholder="目录指标名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.type" clearable placeholder="评价类型">
                        <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            &nbsp;
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd('',1)">新增</el-button>
                <el-button type="danger"  v-if="currUserId == 1" @click="setCopy()">复制</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                :tree-props="{children: 'children'}">
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="text" label="目录指标名称"  fixed  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="attributes.name" label="绑定维度"  :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.name !=null ">
                            {{scope.row.attributes.name}}
                        </div>
                        <div v-else-if="scope.row.attributes.indicatorsType ==2">
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.type" label="评价类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.type == 1">
                            表扬
                        </div>
                        <div v-else-if="scope.row.attributes.type == 2">
                            <span style="color:red;">待改进</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.score" label="分数值"></el-table-column>
                <el-table-column prop="" label="奖章图标"  :show-overflow-tooltip="true" width="90px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.attributes.iconUrl != null && scope.row.attributes.iconUrl != ''">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.attributes.iconUrl" lazy="loading"
                                    style="max-height:250px; max-width:330px;background-color:#d0d0d0;"/>
                                <img slot="reference" :src="scope.row.attributes.iconUrl"  lazy="loading" :alt="scope.row.attributes.iconUrl" style="max-height: 50px;max-width: 130px;background-color:#d0d0d0;">
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="attributes.orderNum" label="排序号" width="60"></el-table-column>
                <el-table-column fixed="right" label="操作" width="140px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  v-if="scope.row.attributes.indicatorsType == 1 && currUserId == 1""
                            @click.native.prevent="setCopyEvaluateAndCataLog(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">复制</span>
                        </el-button>
                        <el-button  v-if="scope.row.attributes.indicatorsType == 1"
                            @click.native.prevent="setAdd(scope.row,2)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <div v-if="setCopyVisible">
            <setCopy ref="setCopy"></setCopy>
        </div>
        <!--复制指标与指标目录数据 -->
        <div v-if="setEvaluateAndCatalogCopyVisible">
            <setEvaluateAndCatalogCopy ref="setEvaluateAndCatalogCopy"></setEvaluateAndCatalogCopy>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './AddIndicators.vue';
    import update from './UpdateIndicators.vue';
    import setCopy from './SetEvaluateIndicatorsDefineCopy.vue';
    import setEvaluateAndCatalogCopy from './SetEvaluateAndCatalogCopy.vue';

    export default {
        name:"EvaluateMain",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                setCopyVisible:false,
                setEvaluateAndCatalogCopyVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    title:"",
                    type:"",
                },
                data:[],
                depts:[],
                types:[{
                    value: 0,
                    label: '全部'
                },{
                    value: 1,
                    label: '表扬'
                },{
                    value: 2,
                    label: '待改进'
                }],
                currUserId:"",
                targetEvaluateId:""
            }
        },
        components: {
            add,update,setCopy,setEvaluateAndCatalogCopy
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateIndicatorsDefineTreeListUrl;
                let data = {
                    deptId:this.form.deptId,
                    title:this.form.title,
                    type:(this.form.type=='0'?'':this.form.type)
                };
                this.apiPost(url,data).then((res) => {
                    console.log(res.data);
                    if(res.status==200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(row,type){
                this.addVisible=true;
                this.$nextTick(() => {
                    // type:1-顶级新增，2-子级新增
                    if(type == 1){
                        this.$refs['add'].init("",this.form.deptId,type);
                    }else if(type == 2){
                        this.$refs['add'].init(row.id,this.form.deptId,type);
                    }
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.evaluateIndicatorsDefineRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 复制-当前学校复制到目标学校
            setCopy(){ 
                this.setCopyVisible=true;
                this.$nextTick(() => {
                    this.$refs['setCopy'].init(this.form.deptId);
                })
            },
            // 复制-复制评价指标与目录数据
            setCopyEvaluateAndCataLog(data){
                this.setEvaluateAndCatalogCopyVisible=true
                this.$nextTick(() => {
                    // 过滤当前学校
                    let deptList = []
                    for(let i=0;i<this.depts.length;i++){
                        let dept = this.depts[i]
                        if(this.form.deptId != dept.id 
                            && dept.name .indexOf('荆溪学区行政') == -1){
                            deptList.push(this.depts[i])
                        }
                    }
                    this.targetEvaluateId = data.id
                    this.$refs['setEvaluateAndCatalogCopy'].init(this.form.deptId, data.id, deptList)
                })
            },
            setEvaluateAndCatalogData(srcEvaluateId){
                console.log("源评价ID",srcEvaluateId)
                let url  = this.evaluateIndicatorsDefineCopyEvaluateAndCataLogDataUrl
                let data = {
                    targetDeptId:this.form.deptId,
                    srcEvaluateId:srcEvaluateId,
                    targetEvaluateId:this.targetEvaluateId,
                };
                
                this.loading=true
                this.apiPost(url,data).then((res) => {
                    console.log(res.data)
                    if(res.status==200){
                        this.getData()
                    }else{
                        this.loading=false
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    this.loading=false
                    console.log(err)
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateIndicatorsDefine.vue